var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomBirthdayCake = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.837 9.427c1.195 0 2.16-.965 2.16-2.16 0-.403-.115-.792-.303-1.109l-1.857-3.21-1.858 3.21a2.202 2.202 0 0 0-.302 1.11c0 1.194.965 2.16 2.16 2.16z",
    fill: "#F2AE18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.317 12.667h-5.4v-2.16h-2.16v2.16h-5.4a3.245 3.245 0 0 0-3.24 3.24v1.656a2.12 2.12 0 0 0 3.614 1.498l2.304-2.304 2.304 2.304c.792.792 2.189.792 2.995 0l2.304-2.304 2.304 2.304a2.12 2.12 0 0 0 3.614-1.498v-1.656a3.245 3.245 0 0 0-3.24-3.24z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.805 20.213-1.167-1.167-1.166 1.167c-1.411 1.411-3.874 1.411-5.285 0l-1.166-1.167-1.167 1.167a3.655 3.655 0 0 1-2.635 1.094 3.727 3.727 0 0 1-2.117-.662v4.982c0 .59.49 1.08 1.08 1.08h17.28c.59 0 1.08-.49 1.08-1.08v-4.982a3.693 3.693 0 0 1-4.737-.432z",
    fill: "#623424"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomBirthdayCake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-birthday-cake.817ecb5cd34065dc44910d835d1056e1.svg";